import { useNavigate } from "react-router-dom";
import { Lock, Sparkles } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";

// Verrouille un module en mode démo : le contenu réel n'est jamais monté
// (donc jamais chargé), on affiche un aperçu flouté « Réservé aux membres ».
export default function DemoLock({ title, description, children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  if (!user?.is_demo) return children;

  return (
    <div className="relative min-h-[70vh]" data-testid="demo-lock">
      {/* Faux aperçu décoratif flouté (aucune donnée réelle) */}
      <div
        aria-hidden="true"
        className="pointer-events-none select-none blur-md opacity-60 space-y-4"
      >
        <div className="h-9 w-64 rounded-lg bg-slate-200" />
        <div className="h-4 w-80 rounded bg-slate-100" />
        <div className="grid gap-4 md:grid-cols-3 mt-6">
          {[0, 1, 2].map((i) => (
            <div key={i} className="h-28 rounded-xl bg-slate-100 border border-slate-200" />
          ))}
        </div>
        <div className="mt-6 space-y-3">
          {[0, 1, 2, 3, 4].map((i) => (
            <div key={i} className="h-12 rounded-lg bg-slate-100 border border-slate-200" />
          ))}
        </div>
      </div>

      {/* Calque de verrouillage */}
      <div className="absolute inset-0 flex items-center justify-center p-4">
        <div
          data-testid="demo-lock-card"
          className="max-w-md w-full text-center rounded-2xl border border-slate-200 bg-white/90 backdrop-blur-md shadow-xl px-8 py-10"
        >
          <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-[hsl(var(--primary))]/10">
            <Lock className="h-7 w-7 text-[hsl(var(--primary))]" />
          </div>
          <div className="inline-flex items-center gap-1.5 rounded-full bg-[hsl(var(--primary))]/10 px-3 py-1 text-xs font-semibold text-[hsl(var(--primary))] mb-3">
            <Sparkles className="h-3.5 w-3.5" /> Réservé aux membres
          </div>
          <h2 className="font-heading text-2xl font-bold text-slate-900">
            {title}
          </h2>
          <p className="mt-2 text-sm text-slate-600">
            {description ||
              "Cette fonctionnalité est disponible une fois votre compte Gestimmony créé. Elle n'est pas accessible dans la démo."}
          </p>
          <Button
            data-testid="demo-lock-signup"
            className="mt-6 w-full"
            onClick={async () => {
              await logout();
              navigate("/register");
            }}
          >
            Créer mon compte pour y accéder
          </Button>
        </div>
      </div>
    </div>
  );
}
